import { useState, useEffect } from "react";

export interface UseNetworkStatusReturn {
    isOnline: boolean;
    isOffline: boolean;
}

export const useNetworkStatus = (): UseNetworkStatusReturn => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = (): void => {
            setIsOnline(true);
        };

        const handleOffline = (): void => {
            setIsOnline(false);
        };

        // Add event listeners for network status changes
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        // Cleanup event listeners on unmount
        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    return {
        isOnline,
        isOffline: !isOnline,
    };
};
